// types
import { EntitySearchInputProps } from './EntitySearchInput.types';

// styles
import { ButtonIcon } from 'components/mrp/mrp.styles';
import {
  EntitySearchIcon,
  EntitySearchTextField
} from './EntitySearchInput.styles';
import { forwardRef } from 'react';
import { Box } from '@mui/material';

const EntitySearchInput = forwardRef(
  (
    {
      params,
      autoFocus = false,
      placeholder,
      useAsDummy = false,
      handleReset,
      onEnterPress,
      onCharacterInput,
      onBlur
    }: EntitySearchInputProps,
    ref
  ) => {
    const handleKeyDown = (event) => {
      if (!useAsDummy) {
        return;
      }

      if (event.code == 'Enter') {
        onEnterPress?.();
        return;
      }

      if (event.code == 'Tab') {
        return;
      }

      // Printable keys usually produce a `key` string of length 1
      if (
        event.key.length === 1 &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.altKey
      ) {
        // This is a typical text character
        onCharacterInput?.(event.key);
        // We don't actually want the character to appear in the dummy field.
        event.preventDefault();
      }
    };

    return (
      <Box>
        <EntitySearchTextField
          {...params}
          autoFocus={autoFocus}
          inputRef={ref}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          onBlur={onBlur}
          slotProps={{
            input: {
              ...params?.InputProps,
              sx: { ...(useAsDummy && { pointerEvents: 'none' }) },
              startAdornment: <EntitySearchIcon type="magnifying-glass" />,
              endAdornment: (() =>
                params?.inputProps.value ? (
                  <ButtonIcon
                    type="xmark"
                    onClick={handleReset}
                    tabIndex={-1}
                    sx={{ color: 'text.secondary' }}
                  />
                ) : null)(),
              style: {
                paddingRight: 0
              }
            }
          }}
        />
      </Box>
    );
  }
);

export default EntitySearchInput;
